export const ARABIC = "ARABIC";
export const ENGLISH = "ENGLISH";

export const LEFT_TO_RIGHT = "LEFT_TO_RIGHT";
export const RIGHT_TO_LEFT = "RIGHT_TO_LEFT";
